<template>
  <div class="flex flex-col pb-4">
    <div v-if="rangeMode" class="text-xs text-surface-500 mb-3">
      <template v-if="range[0]">
        מ-<b>{{ fmt(range[0]) }}</b> עד <b>{{ range[1] ? fmt(range[1]) : '…' }}</b>
      </template>
      <template v-else>בחרו תאריך התחלה וסיום</template>
    </div>
    <div v-else-if="subtitle" class="text-xs text-surface-500 mb-3">{{ subtitle }}</div>

    <DateGridCalendar
      v-if="rangeMode"
      v-model="range"
      mode="range"
      :minDate="minDate"
      :maxDate="maxDate"
    />
    <DateGridCalendar
      v-else
      v-model="selected"
      :minDate="minDate"
      :maxDate="maxDate"
    />

    <!-- Actions -->
    <div class="flex gap-2 mt-4">
      <button
        v-if="rangeMode"
        type="button"
        class="px-4 py-2.5 rounded-xl border border-surface-200 text-xs font-medium text-surface-700"
        @click="clearRange"
      >ניקוי</button>
      <button
        v-else
        type="button"
        class="px-4 py-2.5 rounded-xl border border-surface-200 text-xs font-medium text-surface-700"
        @click="goToToday"
      >היום</button>
      <button
        type="button"
        class="flex-1 py-2.5 rounded-xl text-[13px] font-semibold transition-colors"
        :class="canConfirm ? 'bg-primary text-white' : 'bg-surface-200 text-surface-400'"
        @click="confirm"
      >אישור</button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { DateGridCalendar, useDrawer } from '@torim-app/shared-components';

const props = defineProps<{
  /** 'single' (default) picks one date via onPick; 'range' picks start–end via onPickRange */
  mode?: 'single' | 'range';
  date?: Date;
  startDate?: Date;
  endDate?: Date;
  subtitle?: string;
  minDate?: Date;
  maxDate?: Date;
  onPick?: (date: Date) => void;
  onPickRange?: (start: Date, end: Date) => void;
}>();

const { closeDrawer } = useDrawer();

const rangeMode = props.mode === 'range';

const validDate = (d?: Date): Date | null => (d && !isNaN(d.getTime()) ? d : null);

const selected = ref<Date>(validDate(props.date) ?? validDate(props.startDate) ?? new Date());
const range = ref<Array<Date | null>>([validDate(props.startDate), validDate(props.endDate)]);

const fmt = (d: Date) => `${d.getDate()}.${d.getMonth() + 1}`;

const goToToday = () => {
  selected.value = new Date();
};

const clearRange = () => {
  range.value = [null, null];
};

const canConfirm = computed(() => (rangeMode ? !!(range.value[0] && range.value[1]) : true));

const confirm = () => {
  if (!canConfirm.value) return;
  if (rangeMode) {
    props.onPickRange?.(range.value[0]!, range.value[1]!);
  } else {
    const d = selected.value;
    props.onPick?.(new Date(d.getFullYear(), d.getMonth(), d.getDate()));
  }
  closeDrawer();
};
</script>
